<template>
  <div v-if="noAuth && false">
    您好，欢迎登录~
  </div>
  <div v-else class="wrapper">
  <div class="home">
    <!-- 推荐 -->
    <el-card shadow="hover">
      <div slot="header">
        <span>{{ $t('message.card.title4') }}</span>
      </div>
      <el-row :gutter="15" class="home-recommend-row">
        <el-col :sm="24" :md="12" :lg="6" :xl="6">
          <div class="home-recommend" :style="{ 'background-color': '#48D18D' }">
            <i class="el-icon-data-analysis" :style="{ color: '#64d89d' }"></i>
            <div class="home-recommend-auto">
              <div>今日系统用户：<span
                  style="font-size: 20px;font-weight: bold;">{{totinfo.tot1 || 0}}</span>
              </div>
              <div class="home-recommend-msg">
				系统总用户：{{totinfo.tot2 || 0}}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6">
          <div class="home-recommend" :style="{ 'background-color': '#F95959' }">
            <i class="el-icon-user" :style="{ color: '#F86C6B' }"></i>
            <div class="home-recommend-auto">
              <div>今日提交信息：<span
                  style="font-size: 20px;font-weight: bold;">{{totinfo.tot3 || 0}}</span>
              </div>
              <div class="home-recommend-msg">
                系统总提交信息：{{totinfo.tot4 || 0}}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6">
          <div class="home-recommend" :style="{ 'background-color': '#8595F4' }">
            <i class="el-icon-data-line" :style="{ color: '#92A1F4' }"></i>
            <div class="home-recommend-auto">
              <div>今日审核信息：<span style="font-size: 20px;font-weight: bold;">{{totinfo.tot5 || 0}}</span></div>
              <div class="home-recommend-msg">
                系统总审核数量：{{totinfo.tot6 || 0}}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6">
          <div class="home-recommend" :style="{ 'background-color': '#FEBB50' }">
            <i class="el-icon-coin" :style="{ color: '#FDC566' }"></i>
            <div class="home-recommend-auto">
              <div>今日处理信息：<span style="font-size: 20px;font-weight: bold;">{{totinfo.tot7 || 0}}</span></div>
              <div class="home-recommend-msg">系统总处理信息：{{totinfo.tot8 || 0}}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
	<!-- charts -->
	<el-row :gutter="15" class="mt15">
	  <!-- 图表 -->
	  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
	    <el-card shadow="hover" style="height: 395px" v-loading="table_loading1">
	      <div class="charts">
	        <div class="charts-left mr7">
	          <div ref="homeLaboratoryRefa" class="h150"></div>
	        </div>
	      </div>
	    </el-card>
	  </el-col>
	  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
		<el-card shadow="hover" style="height: 395px" v-loading="table_loading2">
		  <div class="charts">
			<div class="charts-left mr7">
			  <div ref="homeLaboratoryRefb" class="h150"></div>
			</div>
		  </div>
		</el-card>
	  </el-col>
	</el-row>
  </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {CountUp} from 'countup.js';
import {Session} from '@/utils/storage';
import {formatAxis, formatDate} from '@/utils/formatTime';
import {recommendList, chartsRightList, newsInfoList, dailyMessage} from './mock';
import {dashboardApi} from '@/api/dashboard/index';
import {apis} from "@/api/infos";
import {SvgIcon} from '@/components/SvgIcon';

export default {
  beforeDestroy() {
    // 清理图表实例
    if (this.global.homeChartOne) {
      this.global.homeChartOne.dispose();
    }
    if (this.global.homeChartTwo) {
      this.global.homeChartTwo.dispose();
    }
  },
  name: 'home',
  components: {
    SvgIcon
  },
  data() {
    return {
      recommendList,
      chartsRightList,
      newsInfoList,
      // 用户信息
      userInfo: {},
      dailyMessage: {},
      charts: {
        theme: '',
        bgColor: '',
      },
      global: {
        homeChartOne: null,
        homeChartTwo: null,
        homeCharThree: null,
        dispose: [null, '', undefined],
      },
      totinfo: {
        tot1: 0,
        tot2: 0,
        tot3: 0,
        tot4: 0,
        tot5: 0,
        tot6: 0,
        tot7: 0,
        tot8: 0  
      },
      loading: true,//加载状态
      roleId: 0,
      table_loading1: true,
      table_loading2: true
    };
  },
  created() {
	console.log(123);
	this.gettot();
  },
  computed: {
    noAuth(){
      return this.roleId == 6 || this.roleId == 7
    },
    currentTime() {
      return formatAxis(new Date());
    },
    optionSingleHeight() {
      return {
        singleHeight: 28,
        limitMoveNum: 8,
        waitTime: 2000,
      };
    },
    getUserInfos() {
      return this.$store.state.userInfos.userInfos;
    },
  },
  mounted() {
    this.roleId = Session.get('roleId')
    // if(this.noAuth) return
	  this.inittable();
  },
  methods: {
	gettot(){
		this.loading = true;
		let api = apis();
		api.gettot().then(res => {
		  this.totinfo = res.data;
		  this.loading = false;
		})
	},
	inittable() {
    // 修复图表初始化逻辑
    if (this.global.homeChartOne && !this.global.dispose.some((b) => b === this.global.homeChartOne)) {
      this.table_loading1 = true;
      this.global.homeChartOne.dispose();
    }
    if (this.global.homeChartTwo && !this.global.dispose.some((b) => b === this.global.homeChartTwo)) {
      this.table_loading2 = true;
      this.global.homeChartTwo.dispose();
    }
  
    // 初始化两个图表容器
    this.global.homeChartOne = echarts.init(this.$refs.homeLaboratoryRefa, this.charts.theme);
    this.global.homeChartTwo = echarts.init(this.$refs.homeLaboratoryRefb, this.charts.theme);
    
    // 获取数据并渲染图表
    const day = 7;
    
    dashboardApi().indexChart(day).then(res => {
      // 折线图配置
      const lineOption = {
        backgroundColor: this.charts.bgColor,
        title: {
          text: '数据提交量统计',
          left: 'center'
        },
        grid: {
          top: 60,
          right: 20,
          bottom: 30,
          left: '10%'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: res.data.atable_xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: res.data.atable_yAxis,
          type: 'line',
          smooth: true,
          itemStyle: {
            color: '#409EFF'
          },
          areaStyle: {
            color: '#409EFF',
            opacity: 0.3
          }
        }]
      };

      // 饼图配置
      const pieOption = {
        backgroundColor: this.charts.bgColor,
        title: {
          text: '职能部门分布图',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [{
          type: 'pie',
          radius: '70%',
          center: ['50%', '60%'],
          data: res.data.btable,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };

      // 设置图表选项
      this.global.homeChartOne.setOption(lineOption);
      this.table_loading1 = false;
      this.global.homeChartTwo.setOption(pieOption);
      this.table_loading2 = false;

      // 响应窗口大小变化
      const handleResize = () => {
        this.global.homeChartOne.resize();
        this.global.homeChartTwo.resize();
      };

      window.addEventListener('resize', handleResize);
    }).catch(error => {
      console.error('获取图表数据失败:', error);
    });
  },
  // 初始化登录信息
    initUserInfo() {
      if (!Session.get('userInfo')) return false;
      this.userInfo = Session.get('userInfo');
      this.userInfo.time = formatDate(new Date(this.userInfo.time), 'YYYY-mm-dd HH:MM:SS');
    },
    // 消息通知当前项点击
    onNewsInfoListClick(v) {
      window.open(v.link);
    },
  },
  watch: {
    // 监听 vuex 数据变化
    '$store.state.themeConfig.themeConfig.isIsDark': {
      handler(isIsDark) {
        this.$nextTick(() => {
          this.charts.theme = isIsDark ? 'dark' : '';
          this.charts.bgColor = isIsDark ? 'transparent' : '';
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
.h150 {
  width: 100%;
  height: 300px; // 设置固定高度
}
.rank-con {
  position: relative;
  .rank-tip {
    position: absolute;
    left: 50%;
    top: -40px;
    margin-left: -50px;
    width: 100px;
    height: 33px;
    text-align: center;
    line-height: 30px;
    border-radius: 17px;
    font-size: 15px;
    font-weight: 500;
    color: #fff
  }

}

.tit {
  font-size: 18px;
  margin-top: 12px;
}

.tit4 {
  margin-top: 10px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}

.qian4 {
  line-height: 35px !important;
  margin-top: 10px !important
}

.qian {
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  color: #000
}

.rank-item0 {
  color: #e53939
}

.info-item {
  background-color: #f8f9fc;
  //font-size: 43px;
  border-radius: 10px;
  //color: red;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
